export const formatDateTime = (value: string | null): string => {
  if (!value) return '–';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short' });
};
